import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { useDispatch } from 'react-redux';

import { hotjar } from 'shared/util/hotjar-pre-next11';
import { clearObject } from '@/ducks/object/objectActions';
import { wrapper } from '@/store/store';

import '@/styles/common.css';
import '@/styles/favoriteHeartComponent.css';
import '@/styles/feedback.css';
import '@/styles/profile.css';
import '@/styles/map.css';

const FhhApp = ({ Component, pageProps }) => {
    const router = useRouter();
    const dispatch = useDispatch();

    useEffect(() => {
        // Need this to prevent old object data from showing on new object pages, by removing the data when going back to resultpage
        // currently no easy way to test this fix, since it will need to access redux store directly,
        // maybe with something like https://github.com/RcKeller/cypress-redux
        const removeCurrentObjectData = (url, { shallow }) => {
            if (url.includes('/resultat') && shallow === false) {
                dispatch(clearObject());
            }
        };
        router.events.on('routeChangeComplete', removeCurrentObjectData);

        return () => {
            router.events.off('routeChangeComplete', removeCurrentObjectData);
        };
    }, []);

    return (
        <>
            <Head>
                {hotjar(
                    !!pageProps?.unleash?.hotjar &&
                        !pageProps?.unleash?.hotjarCalendar &&
                        !pageProps?.unleash?.hotjarPriceSettings &&
                        !!pageProps?.hasLegalBasis
                )}
            </Head>
            <Component {...pageProps} />
        </>
    );
};

FhhApp.propTypes = {
    Component: PropTypes.func.isRequired,
    pageProps: PropTypes.object.isRequired,
};

export default wrapper.withRedux(FhhApp);
